import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './css/animate.css';
import './css/color.css';
import './css/elpath.css';
import './css/flaticon.css';
import './css/nice-select.css';
import './css/responsive.css';
import './css/rtl.css';
import './css/module-css/about.css';
import './css/module-css/banner.css';
import './css/module-css/blog-details.css';
import './css/module-css/booking-form.css';
import './css/module-css/cart.css';
import './css/module-css/category.css';
import './css/module-css/chooseus.css';
import './css/module-css/clients.css';
import './css/module-css/contact-info.css';
import './css/module-css/contact.css';
import './css/module-css/destination-details.css';
import './css/module-css/destinations.css';
import './css/module-css/error.css';
import './css/module-css/faq.css';
import './css/module-css/instagram.css';
import './css/module-css/news-sidebar.css';
import './css/module-css/news.css';
import './css/module-css/offers.css';
import './css/module-css/page-title.css';
import './css/module-css/place.css';
import './css/module-css/pricing.css';
import './css/module-css/subscribe.css';
import './css/module-css/testimonial.css';
import './css/module-css/tour-details.css';
import './css/module-css/tour-sidebar.css';
import './css/module-css/tours.css';
import './css/module-css/video.css';
import './css/style.css';
import './App.css';


import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
